module.exports = __webpack_public_path__ + "img/0ef5963.svg";